var angular = require('angular');

export const createLoadingColumn = function () {
    let div = angular.element('<div class="fjs-col leaf-col" >');
    let row = angular.element('<div class="leaf-row">');
    let i = angular.element('<span class="loading">');
    i.addClass('fa fa-refresh fa-spin');
    row.append(i);
    row.html('<div class="apice-load"></div');
    div.append(row);
    return div.get(0);
};

// item render
export const createItemContent = function (cfg, item) {

    let frag = document.createDocumentFragment();
    let label = angular.element('<div>');
    let labelWrapper = angular.element('<div class="flex">');
    let iconAppend = angular.element('<i>');
    let iconAppend2 = angular.element('<i>');
    let conservatore = angular.element('<span>');

    // appended icon
    if (item.isChild || item.has_child || (item.children && !item.children.length)) {
        let icon = '';
        switch (item.type.toLowerCase()) {
            case 'superfondo':
                icon = 'building-o';
                break;
            case 'fondo':
                icon = '';
                break;
            case 'subfondo':
                icon = 'th-list';
                break;
            case 'altro livello':
                icon = 'window-minimize';
                break;
            case 'serie':
            case 'partizione':
            case 'partizioni':
                icon = 'square';
                break;
            case 'sottoserie':
            case 'sottosottoserie':
                icon = 'square-o';
                break;
            case 'unità archivistica':
                icon = 'file';
                break;
            case 'sottofascicolo':
                icon = 'file-o';
                break;
            case 'documento':
                icon = 'newspaper-o';
                break;
            case 'documento iconografica':
                icon = 'file-image-o';
                break;
            case 'manoscritto':
                icon = 'file-text-o';
                break;
            case 'documento bibliografico':
                icon = 'book';
                break;
            case 'corrispondenza':
                icon = 'envelope-open-o';
                break;
            case 'verbale':
                icon = 'file-audio-o';
                break;
            case 'video':
                icon = 'file-video-o';
                break;
            default:
                break;
        }

        // text label
        iconAppend2.addClass('icon-type fa fa-' + icon);
        if (icon === '') {
            iconAppend2.addClass('hidden');
        }
        label.html('<span>' + iconAppend2.prop('outerHTML') + `${(item.num || '')} ${item.name}` + '</span>');

        conservatore.addClass('conservatore small grey-light');
        if (item.url || item.mobile_url) {
            let url = item.url || item.mobile_url;
            conservatore.html(`<a href="${url}" title="Vai alla scheda completa">Vai alla scheda completa</a>`);
            conservatore.click( e => {
                e.stopPropagation();
                window.location.href = url;
            });
            label.append(conservatore);
        } else if (item.conservatore) {
            conservatore.text(item.conservatore);
            label.append(conservatore);
        }

        labelWrapper.append(label);
        // label.prepend();
        frag.appendChild(labelWrapper.get(0));
    } else {
        if (item.type !== 'Fondo') {
            label.html(`<span>${(item.num || '')} ${item.name}</span>`);
        } else {
            label.html(`<span>${item.name}</span>`);
        }

        conservatore.addClass('conservatore small grey-light');
        if (item.url || item.mobile_url) {
            let url = item.url || item.mobile_url;
            conservatore.html(`<a href="${url}" title="Vai alla scheda completa">Vai alla scheda completa</a>`);
            conservatore.click( e => {
                e.stopPropagation();
                window.location.href = url;
            });
            label.append(conservatore);
        } else if (item.conservatore) {
            conservatore.text(item.conservatore);
            label.append(conservatore);
        }
        // if (item.date && (item.isChild || item.has_child)) {
        //     conservatore.text(item.date);
        //     label.append(conservatore);
        // }

        labelWrapper.append(label);

        frag.appendChild(labelWrapper.get(0));
        iconAppend.addClass('fa fa-caret-right');
        frag.appendChild(iconAppend.get(0));
    }

    return frag;
};

export const createSimpleColumn = function (cfg, item, itemCurrent = null) {
    let div = angular.element('<div class="fjs-col">');
    let ulList = angular.element('<ul class="fjs-list">');

    if (item.children) {
        item.children
         .filter(Boolean)
         .filter(i => i.access == 1)
         .forEach(i => {
            let liItem = angular.element('<li class="fjs-item">');
            let aItem = angular.element('<a tabindex="-1">');

            if (itemCurrent && itemCurrent.id === i.id) {
                aItem.addClass('selected');
            }

            aItem.append(createItemContent(cfg, i));
            liItem.append(aItem);
            liItem[0]._item = i;
            ulList.append(liItem);
        });
    }
    div.append(ulList);
    return div.get(0);
};


// WEBPACK FOOTER //
// ./src/js/components/finder/findertreeUtils.js